<template>
    <div class="bg-gray-900 grid lg:grid-cols-2 grid-cols-1 space-around">
        <app-profile class="static h-screen" :student="student" :key="student.id"></app-profile>
        <app-facts class="relative" :facts="facts"></app-facts>
    </div>
</template>

<script>
import Profile from '../Profile'
import Facts from './Facts'
import facts from '../../../data/facts'
import students from '../../../data/students'

export default {
    name: 'SingleProfile',
    data() {
        let myFacts = facts.facts.filter(item => item.sid=== parseInt(this.$route.params.id))[0]
        myFacts = myFacts?myFacts.facts:[];
        console.log(myFacts)
        return {
            student: students.students[this.$route.params.id],
            facts: myFacts
        }
    },
    components: {
        'app-profile': Profile,
        'app-facts': Facts
    }
}
</script>


// WEBPACK FOOTER //
// src/components/profiles/single/Container.vue